"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asDistance = _interopRequireDefault(require("./asDistance"));

var _formatSuccessActivities = _interopRequireDefault(require("./formatSuccessActivities"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getUserLiteralProgression = function getUserLiteralProgression(_ref) {
  var challenge = _ref.challenge,
      userGroupChallengeContribution = _ref.userGroupChallengeContribution,
      t = _ref.t,
      i18n = _ref.i18n;
  var conditions = challenge.conditions;
  var gross = '';
  var literal = '';

  if (!conditions || !userGroupChallengeContribution) {
    return {
      gross: gross,
      literal: literal
    };
  }

  if (conditions.noObjective) {
    var acc = (0, _formatSuccessActivities["default"])({
      activities: userGroupChallengeContribution
    }) || {};

    if (conditions.unit) {
      if (conditions.unit === 'duration') {
        gross = t('ds-challenges.timeframe.remainingtime', _objectSpread({}, acc.duration));
        literal = t('ds-challenges.timeframe.remainingtime', _objectSpread({}, acc.duration));
      } else {
        gross = t("ds-challenges.accumulate.".concat(conditions.unit), {
          acc: acc[conditions.unit]
        });
        literal = t("ds-challenges.accumulate.".concat(conditions.unit), {
          acc: acc[conditions.unit]
        });
      }
    }
  }

  if (conditions.repeat) {
    var activities = userGroupChallengeContribution.activities;
    gross += activities;
    literal += "".concat(activities, " x ");
  }

  if (conditions.minPoints) {
    var points = userGroupChallengeContribution.points,
        point = userGroupChallengeContribution.point;
    gross += points || point;
    literal += "".concat(points || point, " ").concat(t('ds-challenges.objective.point', {
      count: points || point
    }));
  }

  if (conditions.minDistance) {
    var _conditions$types = conditions.types,
        types = _conditions$types === void 0 ? null : _conditions$types;
    var keepUnit = !((types === null || types === void 0 ? void 0 : types.length) === 1 && types[0] === 'Swimming');
    var distance = userGroupChallengeContribution.distance;
    gross += (0, _asDistance["default"])(distance, {
      keepUnit: keepUnit,
      maximumFractionDigits: 2,
      valueOnly: true
    }, t, i18n);
    literal += (0, _asDistance["default"])(distance, {
      maximumFractionDigits: 2,
      keepUnit: keepUnit
    }, t, i18n);
  }

  if (conditions.minClimb) {
    var climb = userGroupChallengeContribution.climb;
    gross += (0, _asDistance["default"])(climb, {
      maximumFractionDigits: 2,
      type: 'climb',
      valueOnly: true
    }, t, i18n);
    literal += (0, _asDistance["default"])(climb, {
      maximumFractionDigits: 2,
      type: 'climb',
      valueOnly: true
    }, t, i18n);
    literal += " ".concat(t('ds-challenges.objective.climb'));
  }

  return {
    gross: gross,
    literal: literal
  };
};

var _default = getUserLiteralProgression;
exports["default"] = _default;
//# sourceMappingURL=getUserLiteralProgression.js.map